export default __webpack_public_path__ + "static/media/az1.17951187.jpeg";